angular.module('impactx.dashboard').controller('DashboardMessagesCtrl', ['$scope', 'dataGen', 'MessageService', '$redirect', DashboardMessagesCtrl]);

function DashboardMessagesCtrl($scope, dataGen, MessageService ,$redirect) {
    $scope.messageService = MessageService;

    dataGen.getData($scope, {}, "/dashboard/messages");

    $scope.redirectToToDo = function () {
        $redirect.redirectTo(null, '/messagetodolist')
    };

    $scope.redirectToInfo = function () {
        $redirect.redirectTo(null, '/messageinfolist')
    };
}